const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function toDate(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value) {
  const date = toDate(value);
  if (!date) {
    return "";
  }
  return date.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
}

// Whole calendar days from `today` until `value`; negative when it lies in the past.
export function daysUntil(value, today = new Date()) {
  const date = toDate(value);
  if (!date) {
    return null;
  }
  const start = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const end = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  return Math.round((end - start) / MS_PER_DAY);
}

export function relativeDays(days) {
  if (days === null) return "";
  if (days === 0) return "heute";
  if (days === 1) return "morgen";
  if (days > 1) return `in ${days} Tagen`;
  if (days === -1) return "gestern";
  return `vor ${Math.abs(days)} Tagen`;
}

// Events in chronological order; events without a valid start date come last.
export function sortByStartDate(events) {
  const time = (event) => toDate(event.startDate)?.getTime() ?? Number.POSITIVE_INFINITY;
  return [...events].sort((a, b) => time(a) - time(b));
}

/**
 * The event with the earliest start date that is today or later.
 * Falls back to the most recent past event when nothing is upcoming.
 */
export function nextEvent(events, today = new Date()) {
  const dated = events
    .map((event) => ({ event, days: daysUntil(event.startDate, today) }))
    .filter((entry) => entry.days !== null);
  const upcoming = dated.filter((entry) => entry.days >= 0).sort((a, b) => a.days - b.days);
  if (upcoming.length > 0) {
    return upcoming[0].event;
  }
  const past = dated.sort((a, b) => b.days - a.days);
  return past.length > 0 ? past[0].event : null;
}
